var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-col footer-wrapper"},[(_vm.$te('General.FooterMessage'))?_c('span',[_vm._v(" "+_vm._s(_vm.$t('General.FooterMessage'))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }